// extracted by mini-css-extract-plugin
module.exports = {"blockSection":"ReviewsBlock_blockSection__4lPwT","ratingCount":"ReviewsBlock_ratingCount__wRyLn"};
module.exports.__checksum = "10d8572458db"
